import { TabularCopySource } from './tabular-type.copysource';
import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { MicrosoftAccessTableDataset } from 'app/model/dataset/microsoft-access-table.dataset';

@Metamodel.model({
    name: adfModelTypeMap.microsoftAccess.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(MicrosoftAccessTableDataset)
        ]
    }
})
export class MicrosoftAccessCopySource extends TabularCopySource {
}
